import { lazy, Suspense } from 'react';
import type { ReactNode } from 'react';
import { createHashRouter } from 'react-router-dom';
import type { RouteObject } from 'react-router-dom';
import Layout from '@/Pages/Layout/Layout';
import ModuleManage from '@/Pages/ModuleManage/ModuleManage';
import Login from '@/Pages/Login/Login';
import Register from '@/Pages/Register/Register';
const PageManage = lazy(() => import('@/Pages/PageManage/PageManage'));
const CopywritingManage = lazy(
	() => import('@/Pages/CopywritingManage/CopywritingManage'),
);
const Log = lazy(() => import('@/Pages/Log/Log'));
const Notdefined = lazy(() => import('@/Pages/Notdefined/Notdefined'));

const lazyLoad = (node: ReactNode): ReactNode => {
	// TODO: add loading 、Skeleton screen
	return <Suspense>{node}</Suspense>;
};
const routersConfig: RouteObject[] = [
	{
		path: '/login',
		element: <Login />,
	},

	{
		path: '/',
		element: <Layout />,
		children: [
			{ index: true, element: <ModuleManage /> },
			{ path: 'page', element: lazyLoad(<PageManage />) },
			{ path: 'copywriting', element: lazyLoad(<CopywritingManage />) },
			{ path: 'register', element: lazyLoad(<Register />) },
			{ path: 'log', element: lazyLoad(<Log />) },
		],
	},

	{
		path: '*',
		element: lazyLoad(<Notdefined />),
	},
];
const Router = createHashRouter(routersConfig);

export { routersConfig };
export default Router;
